import React from "react";
import Intro from "../../component/Intro";
import Footer from "../../component/footer";
import AllMembers from "./Allmembers";

function Teampage({ mode, setmymode }) {
  const textinline5 = {
    headh1: "",
    spano: "Our Team",
    subh1:
      "Our projects are crafted with professional expertise TEAM to meet our customers' needs",
    paragraph1:
      "Our projects are crafted with professional expertise to meet our customers' needs, elevate their fields, and utilize technology to enhance productivity.",
  };
  return (
    <div>
      <Intro mode={mode} setmymode={setmymode} textinline={textinline5} />
      <div>
        <AllMembers mode={mode}/>
      </div>
      <Footer />
    </div>
  );
}

export default Teampage;
